/**
 * Format a number according to the selected currency and locale.
 *
 * Supported currencies: CAD, USD, EUR, GBP, CHF
 * Fallback to en-US if unknown currency.
 *
 * Usage:
 *   formatNumber(1234.5, 'CAD') // "$1,234.50"
 *   formatNumber(1234.5, 'EUR') // "1 234,50 €"
 */
export function formatNumber(
  amount: number,
  currency: string = 'CAD',
  options?: { showSymbol?: boolean }
): string {
  const currencyMap: Record<string, { locale: string; code: string }> = {
    CAD: { locale: 'en-CA', code: 'CAD' },
    USD: { locale: 'en-US', code: 'USD' },
    EUR: { locale: 'sv-SE', code: 'EUR' }, // Swedish locale for EUR, adjust if needed
    GBP: { locale: 'en-GB', code: 'GBP' },
    CHF: { locale: 'de-CH', code: 'CHF' }
  }
  const info = currencyMap[currency] || { locale: 'en-US', code: currency }
  const showSymbol = options?.showSymbol !== false // default true

  return new Intl.NumberFormat(info.locale, {
    style: showSymbol ? 'currency' : 'decimal',
    currency: info.code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount)
}
